import { useMutation, useQuery } from "react-query";
import { usePopup } from "../../common/contexts/PopupContext";
import useUser from "../../common/hooks/pages/useUser";
import ApiValidate from "../../common/components/ApiValidate";
import PagePermissions from "../components/PagePermissions";
import usePermissions from "../../common/hooks/pages/usePermissions";
import { useApp } from "../../common/contexts/AppContext";

function PagePermissionsContainer() {
  const { organizationId } = useApp();

  const { toast } = usePopup();

  const { getPagePermissions } = useUser();

  const { getPermissions } = usePermissions();

  const {
    data: pagePermissionData,
    mutate: pagePermissionsMutate,
    isLoading: isGettingPagePermisions,
    isError: isErrorOnPagePermission,
  } = useMutation({
    mutationFn: getPagePermissions,
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting page permissions!";
      toast(message, "error");
    },
  });

  const { data, isLoading, isError } = useQuery({
    retry: false,
    queryKey: "getPermissions",
    queryFn: getPermissions,
    onSuccess: () => {
      pagePermissionsMutate(organizationId);
    },
    onError: (error) => {
      const message =
        error?.response?.data?.message ||
        "Something went wrong while getting permissions";
      toast(message, "error");
    },
  });

  const { permissions = [] } = data?.data || {};

  const { isOwner, pagePermissions = [] } = pagePermissionData?.data || {};

  return (
    <ApiValidate isLoading={isLoading} isError={isError}>
      <PagePermissions
        permissions={permissions}
        pagePermissions={pagePermissions}
        isOwner={isOwner}
        isGettingPagePermisions={isGettingPagePermisions}
        isErrorOnPagePermission={isErrorOnPagePermission}
      />
    </ApiValidate>
  );
}

export default PagePermissionsContainer;
